import { render } from "./HomeTeam.vue?vue&type=template&id=4ed30372"
import script from "./HomeTeam.vue?vue&type=script&lang=js"
export * from "./HomeTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__